import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-manual',
  templateUrl: './user-manual.component.html',
  styleUrls: ['./user-manual.component.scss']
})
export class UserManualComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    this.linkUrl();
   // this.openUrl();
  }

  // openUrl(){
  //   window.location.href='https://www.pay10.com/plugin.php';
  // }
  linkUrl(){
    window.open('https://globaldev.pay10.com/documents/Usermanual.pdf','_blank')
    // if(subitem=="/merchants/merchantReport"){
    //  window.open('../../../../assets/images/User manual.pdf','_blank')

    // }
  }
}
